export default "__VITE_ASSET__C8YGDRT9__"